import { useFormikContext } from "formik";
import React from "react";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Button from "react-bootstrap/esm/Button";
import { Link } from "react-router-dom";

export const ResetPasswordSubmission = ({ isSubmitted }) => {
    const { isSubmitting, status } = useFormikContext(); // use to disable button while the request is being made to server and to check for successful api call

    let statusMessage = "";

    if (status?.error === true) {
        statusMessage = (
            <p className="text-danger">Error with resetting password</p>
        );
    } else if (status?.error === false) {
        statusMessage = (
            <p className="text-success">
                Sent a link to reset the password associated with the provided
                email
            </p>
        );
    } else {
        statusMessage = "";
    }

    return (
        <>
            <Row>{statusMessage}</Row>
            {!isSubmitted && (
                <>
                    <Row>
                        <Col>
                            <Button
                                className="btn btn-primary"
                                type="submit"
                                disabled={isSubmitting}
                            >
                                Submit
                            </Button>
                        </Col>
                        <Col>
                            <Row>
                                <Col className="d-flex justify-content-end">
                                    <Link to="/signin">Sign in</Link>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </>
            )}
        </>
    );
};
